import { useQuery } from 'convex/react';
import { api } from '../convex/_generated/api';
import { useAuthData } from './useAuthData';

/**
 * Friends' visited restaurants (Convex query). Each item is `{ _id, name }` — same idea as
 * `getUserVisitedRestaurants`, without extra fields. `undefined` while loading / skipped.
 */
export function useFriendsVisitedRestaurants() {
  const { authData } = useAuthData();

  return useQuery(
    api.friends.getFriendsVisitedRestaurants,
    authData?.privyDid ? { privyDid: authData.privyDid } : 'skip'
  );
}
